module.exports = __webpack_public_path__ + "static/media/person7.3bc87d78.svg";